"use client";
import { keys } from "../../utils/keys/keys.mjs";
import { camelToKebabCase } from "../../utils/camel-to-kebab-case/camel-to-kebab-case.mjs";
//#region packages/@mantine/core/src/core/InlineStyles/css-object-to-string/css-object-to-string.ts
function cssObjectToString(css) {
	return keys(css).reduce((acc, rule) => css[rule] !== void 0 ? `${acc}${camelToKebabCase(rule)}:${css[rule]};` : acc, "").trim();
}
//#endregion
export { cssObjectToString };

//# sourceMappingURL=css-object-to-string.mjs.map